import { useId } from "react";
import { useTranslation } from "react-i18next";

import { DateRange } from "../types/Operator";

const DateRangePicker = ({
    language,
    fromDate,
    toDate,
    onChange
}: {
    language: string;
    fromDate: string;
    toDate: string;
    onChange: (dateRange: DateRange) => void;
}) => {
    const { t } = useTranslation();

    const fromId = useId();
    const toId = useId();

    return (
        <div className="flex gap-2 text-xl">
            <div className="flex flex-col">
                <label htmlFor={fromId}>{t("dateRangePicker.from")}</label>
                <input
                    id={fromId}
                    className="rounded bg-gray-200 p-2"
                    type="date"
                    lang={language}
                    value={fromDate}
                    onChange={(e) =>
                        onChange({
                            from: e.target.value,
                            to: toDate
                        })
                    }
                    max={toDate}
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor={toId}>{t("dateRangePicker.to")}</label>
                <input
                    id={toId}
                    className="rounded bg-gray-200 p-2"
                    type="date"
                    lang={language}
                    value={toDate}
                    onChange={(e) =>
                        onChange({
                            from: fromDate,
                            to: e.target.value
                        })
                    }
                    min={fromDate}
                />
            </div>
        </div>
    );
};

export default DateRangePicker;
